import Vue from 'vue'
import './plugins/axios.js'
import index from './index.vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './css/zidingyi-hui.css'
import toubu from './toubu.vue'
import dibu from './dibu.vue'
import mianban from './mianban.vue'

Vue.config.productionTip = false

Vue.use(Element);
Vue.component('gg-toubu',toubu)
//Vue.component('gg-toubu',toubu,{props: ['axios']})
Vue.component('gg-dibu',dibu)
Vue.component('mianban',mianban);

new Vue({
  render: h => h(index),
}).$mount('#app')